module.exports = __webpack_public_path__ + "static/media/tank_truck.3d2c735f.svg";